import Vue from 'vue';

export default [
    {
        pathId: 'tls',
        component: 'tools',
        title: 'Tools',
        icon: 'fa-tools',
        size: 'sm', //sm, md, lg, xl
    },
    {
        pathId: 'tlmm',
        component: 'mass-email',
        title: 'Mass E-Mail',
        icon: 'fa-envelope',
        size: 'lg', //sm, md, lg, xl
    },
    {
        pathId: 'tlrc',
        component: 'reseller-contact',
        title: 'Reseller Contact',
        icon: 'fa-envelope',
        size: 'lg', //sm, md, lg, xl
        loading: true
    },
];

Vue.component('tools', () => import('@/cards/tools/Tools'));
Vue.component('mass-email', () => import('@/cards/tools/MassEmail'));
Vue.component('reseller-contact', () => import('@/cards/tools/ResellerContact'));
